module.exports = __webpack_public_path__ + "img/commitment.b6c5f505.jpg";